var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "zcy-menu" }, [
    _c(
      "div",
      { staticClass: "hd" },
      [
        _c("app-icon", { attrs: { type: "icongonggao" } }),
        _vm._v("\n    采购公告\n  ")
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "bd" },
      [
        _c(
          "a-menu",
          {
            staticStyle: { width: "300px" },
            attrs: {
              selectedKeys: _vm.selectedKeys,
              openKeys: _vm.openKeys,
              mode: "inline"
            },
            on: { click: _vm.handleClick, openChange: _vm.onOpenChange }
          },
          _vm._l(_vm.menus, function(item) {
            return _c(
              "a-sub-menu",
              { key: item.code },
              [
                _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                  _c("span", [_vm._v(_vm._s(item.title))])
                ]),
                _vm._v(" "),
                _vm._l(item.children, function(cur) {
                  return _c("a-menu-item", { key: cur.code }, [
                    _vm._v("\n          " + _vm._s(cur.title) + "\n        ")
                  ])
                })
              ],
              2
            )
          }),
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11aa6800", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11aa6800","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/menu.vue
// module id = QxC6
// module chunks = 1